import { motion, useMotionValue, useSpring } from "framer-motion";
import { ChevronDown, Sparkles } from "lucide-react";
import Countdown from "./Countdown";

const EASE = [0.16, 1, 0.3, 1];

const line = {
  hidden: { y: "120%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 1.1, ease: EASE, delay: 0.3 + i * 0.13 },
  }),
};

const fade = {
  hidden: { opacity: 0, y: 16 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE, delay: 1.2 + i * 0.15 },
  }),
};

function Masked({ i, className, as: Tag = "span", children }) {
  return (
    <span className="mask">
      <motion.span
        as={Tag}
        className={className}
        custom={i}
        variants={line}
        initial="hidden"
        animate="show"
      >
        {children}
      </motion.span>
    </span>
  );
}

export default function Hero({ onScrollHint }) {
  const rawX = useMotionValue(0);
  const rawY = useMotionValue(0);
  const rotateX = useSpring(rawX, { stiffness: 90, damping: 18 });
  const rotateY = useSpring(rawY, { stiffness: 90, damping: 18 });

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    rawX.set(((e.clientY - r.top) / r.height - 0.5) * -7);
    rawY.set(((e.clientX - r.left) / r.width - 0.5) * 9);
  };

  const reset = () => {
    rawX.set(0);
    rawY.set(0);
  };

  return (
    <section className="hero" onMouseMove={onMove} onMouseLeave={reset}>
      <div className="invite-container">
        <motion.div
          className="card"
          data-testid="hero-card"
          initial={{ opacity: 0, y: 30, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 1.2, ease: EASE }}
          style={{ rotateX, rotateY, transformPerspective: 1000 }}
        >
          <div className="corner-gem corner-tl" />
          <div className="corner-gem corner-tr" />
          <div className="corner-gem corner-bl" />
          <div className="corner-gem corner-br" />
          <div className="aura-glow" />

          <div className="card-content">
            <Masked i={0} className="badge-chapter">
              Chapter Eighteen
            </Masked>

            <Masked i={1} className="number-18">
              18<sup>°</sup>
            </Masked>

            <Masked i={2} className="name-hero">
              Ginevra Mosi
            </Masked>

            <Masked i={3} className="tagline">
              “Una notte speciale per brindare insieme
              <br />
              e accendere un nuovo inizio.”
            </Masked>

            <motion.div custom={0} variants={fade} initial="hidden" animate="show">
              <span className="dress-code">
                <Sparkles size={13} strokeWidth={1.8} />
                <span>Dress Code: Black &amp; Chic</span>
              </span>
            </motion.div>

            <Masked i={4} className="date-highlight">
              VENERDÌ 20 NOVEMBRE
            </Masked>

            <motion.div
              custom={1}
              variants={fade}
              initial="hidden"
              animate="show"
            >
              <Countdown />
            </motion.div>
          </div>
        </motion.div>
      </div>

      <motion.button
        className="scroll-hint"
        data-testid="scroll-hint"
        aria-label="Scorri ai dettagli"
        onClick={onScrollHint}
        animate={{ y: [0, 8, 0] }}
        transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
      >
        <ChevronDown size={17} strokeWidth={1.8} />
      </motion.button>
    </section>
  );
}
